import { InjectionToken } from '@angular/core';
import { IpqsConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const IPQS_CONFIG: InjectionToken<IpqsConfig> = new InjectionToken<IpqsConfig>('IpqsConfig');
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IPQS_REGISTER_IP_CHECK_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>(
  'IpqsRegisterIpCheckEnabled',
  {
    factory: () => false
  }
);
